module.exports = __webpack_public_path__ + "img/page-loading.96ad817e.gif";